<template>
  <div class="main_o clearfix position-relative">
    <div class="main_1 clearfix position-absolute top-0 w-100">
      <HeaderItem />
    </div>
    <div class="main_2 clearfix">
      <section id="center" class="center_about">
        <div class="center_om clearfix">
          <div class="container-xl">
            <div class="row center_o1">
              <div class="col-md-12">
                <h2 class="text-white">About</h2>
                <h6 class="mb-0 mt-3 fw-normal col_oran">
                  <a class="text-light" href="#">Home</a>
                  <span class="mx-2 col_light">/</span> About
                </h6>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <section id="about_pg" class="p_3">
    <div class="container-xl">
      <div class="about_pg1 row car_card">
        <div class="col-md-6">
          <div class="about_pgl clearfix">
            <div class="grid clearfix">
              <figure class="effect-jazz mb-0">
                <a
                  ><img src="img/kigali.jpg" class="w-100" alt="abc"
                /></a>
              </figure>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="about_pgr clearfix">
            <h4 class="col_oran">ABOUT US</h4>
            <h2>
              Moving With Kigali Rwanda Car Hire is <br />
              Always Easy And Fast
            </h2>
            <p class="mt-3">
              Welcome to Discover Kigali Rwanda Car Hire, your premier choice for reliable and comfortable transportation solutions in the heart of Rwanda. At Discover Kigali, we take pride in offering a seamless and enjoyable car rental experience tailored to your needs.
            </p>
            <p>
              <i class="fa fa-check-circle col_oran me-1"></i> Our fleet consists of a diverse range of vehicles, from fuel-efficient compact cars to spacious SUVs, ensuring there's a perfect match for every journey.
            </p>
            <p>
              <i class="fa fa-check-circle col_oran me-1"></i> We believe in making quality transportation accessible to everyone. Enjoy competitive and transparent pricing with no hidden fees.
            </p>
            <p>
              <i class="fa fa-check-circle col_oran me-1"></i> Our team is dedicated to exceeding customer expectations. From reservation to drop-off, we are committed to making your car rental experience smooth and enjoyable.
            </p>
            <h6 class="mb-0">
              <!-- <a class="button" href="#"
                >Discover More <i class="fa fa-check-circle ms-1"></i>
              </a> -->
            </h6>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="work" class="p_3 bg_light">
    <div class="container-xl">
      <div class="row trip_1 text-center mb-4">
        <div class="col-md-12">
          <h5 class="col_oran">Our Work</h5>
          <h1>How we Work with you </h1>
          <!-- <p class="mb-0">
            To contribute to positive change and achieve our sustainability
            <br />
            goals with many extraordinary
          </p> -->
        </div>
      </div>
      <div class="work_1 row car_card">
        <div class="col-md-3 col-sm-6">
          <div class="work_i clearfix position-relative">
            <div class="work_i1 clearfix">
              <a
                ><img alt="abc" class="w-100" src="img/02f18275-7609-4f7a-932c-3bf0b5c6e999.jpeg"
              /></a>
            </div>
            <div class="work_i2 text-center clearfix position-absolute w-100">
              <span class="fs-4 d-inline-block bg_oran text-white">1</span>
            </div>
          </div>
          <div class="work_i_last text-center mt-5 clearfix">
            <h5><a href="#">Choose a Service</a></h5>
            <p class="mb-0">
              <!-- Aute irure dolor reprehenderit velit esse cillum dolore fugiat -->
            </p>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="work_i clearfix position-relative">
            <div class="work_i1 clearfix">
              <a
                ><img alt="abc" class="w-100" src="img/cf7aff55-fddd-4f37-913f-02cd12ccc39b.jpeg"
              /></a>
            </div>
            <div class="work_i2 text-center clearfix position-absolute w-100">
              <span class="fs-4 d-inline-block bg_oran text-white">2</span>
            </div>
          </div>
          <div class="work_i_last text-center mt-5 clearfix">
            <h5><a href="#">Request a Car Rent</a></h5>
            <p class="mb-0">
              <!-- Aute irure dolor reprehenderit velit esse cillum dolore fugiat -->
            </p>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="work_i clearfix position-relative">
            <div class="work_i1 clearfix">
              <a
                ><img alt="abc" class="w-100" src="img/941d6f6d-1b65-4414-be70-02e292f273f5.jpeg"
              /></a>
            </div>
            <div class="work_i2 text-center clearfix position-absolute w-100">
              <span class="fs-4 d-inline-block bg_oran text-white">3</span>
            </div>
          </div>
          <div class="work_i_last text-center mt-5 clearfix">
            <h5><a href="#">Receive Custom Plan</a></h5>
            <p class="mb-0">
              <!-- Aute irure dolor reprehenderit velit esse cillum dolore fugiat -->
            </p>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="work_i clearfix position-relative">
            <div class="work_i1 clearfix">
              <a @click="bookCar();"
                ><img alt="abc" class="w-100" src="img/88c39049-47ac-40c8-8cc9-a06c72a65b1b.jpeg"
              /></a>
            </div>
            <div class="work_i2 text-center clearfix position-absolute w-100">
              <span class="fs-4 d-inline-block bg_oran text-white">4</span>
            </div>
          </div>
          <div class="work_i_last text-center mt-5 clearfix">
            <h5><a href="#" @click="bookCar();">Let’s Make it Happen</a></h5>
            <p class="mb-0">
              <!-- Aute irure dolor reprehenderit velit esse cillum dolore fugiat -->
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="ride">
  </section>

  <FooterItem />
</template>
<script>
import HeaderItem from '../components/HeaderItem.vue'
import FooterItem from '../components/FooterItem.vue'
export default {
  components: {
    HeaderItem,
    FooterItem
  },
  methods: {
    bookCar () {
      confirm('Are you sure you want to request book a car ?') ? this.confirmBooking() : this.cancelBooking()
    },
    cancelBooking () {
      alert('Booking Car not yet done, Pleases try again')
    },
    confirmBooking () {
      const title = 'Request to Book a CAR TO kigalirwandacarhire.com \n ----------------------------------- \n'
      const phoneNumber = '250782336854'
      const names = '.....................'
      const email = '.....................'
      const customerPhone = '..............'
      const bookDescription = '..................................'
      const message = title + ' CAR NAME: ' + this.carName + '\n Your Names' + names + '\n Your Email: ' + email + '\n Your Phone Number: ' + customerPhone + '\n  Special Request: ' + bookDescription
      const encodedMessage = encodeURIComponent(message)
      const link = `https://wa.me/${phoneNumber}?text=${encodedMessage}`
      window.open(link, '_blank')
    }
  }
}
</script>
